
import React, { useEffect, useState } from 'react'
import { Card, Row, Col, Form, Button } from 'react-bootstrap'
import { useHistory } from 'react-router'
import { useAuth } from '../../../contexts/AuthContext'
import { GenerateRandomNumber, GetCollection, UpdateDocument } from '../../../firebase/firebase'
import { onImageChange, resizeFile } from './AddRecipe.utils'
export const AddRecipeWrapper = () => {
    const history = useHistory()
    const { user } = useAuth()
    const [loading, setLoading] = useState(false)
    const [recipe, setRecipe] = useState({
        id: '',
        title: '',
        image: '',
        ingredients: [],
        directions: [],
        category: ''

    })


    const [image, setImage] = useState(recipe.image)


    const handleSubmit = async (e) => {

        e.preventDefault()


        try {

            let recipeToUpload = { ...recipe }

            recipeToUpload.id = GenerateRandomNumber()
            recipeToUpload.type = 'newFormat'
            recipeToUpload.imagePath = `/recipes/${recipeToUpload.id}`
            await UpdateDocument('recipes', recipeToUpload, true)
            history.push(`/recipes/view/${recipeToUpload.id}`)



        }

        catch (e) {
            return "error"

        }

    }

    const onChange = (e) => {
        setRecipe({ ...recipe, [e.target.name]: e.target.value })
        

    }


    const onDropdownChange = (e, attribute) => {
        setRecipe({...recipe, [attribute]: e.target.value})
    }

    const onImageChange = async (e) => {
        const img = e.target.files[0]
        if (img) {
            const image = await resizeFile(img)
            setRecipe({ ...recipe, ['image']: image })
            setImage(URL.createObjectURL(image))
        }
        else {
            return 'Error'
        }

    }

    const IncrementArray = (e, arr) => {
        const tempRecipe = { ...recipe }
        const tempArray = recipe[arr]
        tempArray.push('')
        setRecipe({ ...recipe, [arr]: tempArray })
    }

    const RemoveFromArray = (e, arr, idx) => {
        const tempRecipe = { ...recipe }
        const tempArray = recipe[arr]
        tempArray.splice(idx, 1)
        setRecipe({ ...recipe, [arr]: tempArray })
    }

    const onArrayChange = (e, arr, idx) => {
        const tempRecipe = { ...recipe }
        const tempArray = recipe[arr]
        tempArray[idx] = e.target.value
        setRecipe({ ...recipe, [arr]: tempArray })
    }

    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Header>
                        Add a Recipe
                    </Card.Header>
                    <Row>
                        <Col md={6} className='text-center mx-auto d-block'>
                            <TitleInput recipe={recipe} onChange={onChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className='text-center mx-auto d-block'>
                            <CategoryInput recipe={recipe} onChange={onDropdownChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className='text-center mx-auto d-block'>
                            <RecipeImageInput recipe={recipe} image={image} onChange={onImageChange} />
                        </Col>

                    </Row>

                    <Row>
                        <Col md={6} className='text-center mx-auto d-block p-3'>
                            <AddRecipeDirections onChange={onArrayChange} onClick={IncrementArray} onRemove={RemoveFromArray} recipe={recipe} />
                        </Col>
                        <Col md={6} className='text-center mx-auto d-block p-3'>
                            <AddRecipeIngredients onChange={onArrayChange} onClick={IncrementArray} onRemove={RemoveFromArray} recipe={recipe} />
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
            <RecipePreview recipe={recipe} handleSubmit={handleSubmit} />

        </>
    )
}

const TitleInput = (props) => {
    const recipe = props.recipe
    return (
        <>
            <Form.Control
                type='text'
                onChange={props.onChange}
                placeholder="Title"
                value={recipe.title}
                name="title"

            />
        </>
    )
}

const CategoryInput = (props) => {
    const recipe = props.recipe
    const [categories, setCategories] = useState([])
    useEffect(() => {
        GetCollection('recipeCategories', false).then((data) => {
            setCategories(data.docs.map((doc) => doc.data()))
        })

    }, [])
    return (
        <>
            <Form.Control as="select" value={recipe.category} onChange={(e) => props.onChange(e, 'category')} custom>
                {categories && categories.map((category, idx) => {
                    return (
                        <option value={category.id} key={idx}>{category.title}</option>
                    )
                })}
            </Form.Control>
        </>
    )
}

const RecipeImageInput = (props) => {
    const recipe = props.recipe
    const image = props.image
    return (
        <>
            <Card.Img
                variant='top'
                src={image}
                className='p-3'
                accept="image/*"
                style={{ height: '300px', width: 'auto' }}
            />
            <Form>
                <label className='btn btn-primary' htmlFor='recipeImage'>Select Image</label>
                <input id='recipeImage' type='file' onChange={props.onChange} style={{ display: 'none' }}></input>
            </Form>
        </>
    )
}


const AddRecipeIngredients = (props) => {
    const recipe = props.recipe
    return (
        <>
            <Card>
                <Card.Body>
                    <h4>Ingredients</h4>
                    <Row>
                        <Col md={2}>
                            <Button onClick={(e) => props.onClick(e, 'ingredients')}>Add</Button>
                        </Col>
                    </Row>
                    <Row className='py-3'>
                        {recipe.ingredients && recipe.ingredients.map((ingredient, idx) => (
                            <Col key={idx} lg={6} className='py-1'>
                                <Row>
                                    <Col key={`${idx}-btn`} md={3} className='py-1'>
                                        <Button variant='danger' onClick={(e) => props.onRemove(e, 'ingredients', idx)}>Delete</Button>
                                    </Col>
                                    <Col key={`${idx}-input`} md={9} className='py-1'>
                                        <Form.Control
                                            type='text'
                                            onChange={(e) => props.onChange(e, 'ingredients', idx)}
                                            placeholder={`Ingredient ${idx + 1}`}
                                            value={ingredient}

                                        />
                                    </Col>

                                </Row>
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>
        </>
    )
}

const AddRecipeDirections = (props) => {
    const recipe = props.recipe
    return (
        <>
            <Card>
                <Card.Body>
                    <h4>Directions</h4>
                    <Row>
                        <Col md={2}>
                            <Button onClick={(e) => props.onClick(e, 'directions')}>Add</Button>
                        </Col>
                    </Row>
                    <Row className='py-3'>
                        {recipe.directions && recipe.directions.map((direction, idx) => (

                            <Row key={idx}>
                                <Col key={`${idx}-btn`} sm={3} className='py-1'>
                                    <Button variant='danger' onClick={(e) => props.onRemove(e, 'directions', idx)}>Delete</Button>
                                </Col>
                                <Col key={`${idx}-input`} md={9} className='py-1'>
                                    <Form.Control
                                        type='text'
                                        onChange={(e) => props.onChange(e, 'directions', idx)}
                                        placeholder={`Directions ${idx + 1}`}
                                        value={direction}

                                    />
                                </Col>

                            </Row>

                        ))}
                    </Row>
                </Card.Body>
            </Card>
        </>
    )
}

const RecipePreview = (props) => {
    const recipe = props.recipe
    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Header>
                        <h4 className='text-center mx-auto d-block'>Preview of {recipe.title}</h4>
                    </Card.Header>
                    <Row>
                        <Col md={6} className='text-center mx-auto d-block'>
                            {recipe.image &&
                                <Card.Img
                                    variant='top'
                                    src={URL.createObjectURL(recipe.image)}
                                    className='p-3'
                                    style={{ height: '300px', width: 'auto' }}
                                />

                            }
                        </Col>

                    </Row>

                    <Row>
                        <Col md={6} className='text-center mx-auto d-block p-3'>
                            <Card>
                                <Card.Body>
                                    <Card.Header>
                                        <h4 className='text-center mx-auto d-block'>Ingredients</h4>
                                    </Card.Header>
                                    {recipe.ingredients && recipe.ingredients.map((ingredient, idx) => (
                                        <Row key={`previewIngredients-${idx}`}>
                                            - {ingredient}
                                        </Row>
                                    ))}
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} className='text-center mx-auto d-block p-3'>
                            <Card>
                                <Card.Body>
                                    <Card.Header>
                                        <h4 className='text-center mx-auto d-block'>Directions</h4>
                                    </Card.Header>
                                    {recipe.directions && recipe.directions.map((direction, idx) => (
                                        <Row key={`previewDirections-${idx}`}>
                                            {idx + 1}: {direction}
                                        </Row>
                                    ))}
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    <Card.Footer>
                        <Row>
                            <Col md={6} className='text-center mx-auto d-block p-3'>
                                <Button onClick={props.handleSubmit}>Submit</Button>
                            </Col>
                        </Row>
                    </Card.Footer>
                </Card.Body>
            </Card>
        </>
    )
}